import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="7.5,11 6,12.5 7.5,14 18.5,25 20,23.4 9.1,12.5 20,1.5 18.5,0 " />
    </g>
  </svg>
);
